import agent from './agent';
import config from '../config.json';
import ServiceBase from './ServiceBase';

const baseUrl = config.baseUrl;

const service = 'homewizard';

class HomeWizardService extends ServiceBase {
    /**
     * Fetches power usage summaries (import/export kWh + costs per period).
     * @param {number} [start] - epoch ms
     * @param {number} [end] - epoch ms
     * @returns {Promise}
     */
    getDayUsages = (start, end) => {
        const qs = start && end ? `?start=${start}&end=${end}` : '';
        const url = `${baseUrl}/${service}/usage/days${qs}`;
        const cfg = { headers: { Authorization: `Bearer ${this.getToken()}` } };
        return agent.get(url, cfg);
    };

    /**
     * Fetches power usage per month (import/export kWh + costs per period).
     * @param {number} [start] - epoch ms
     * @param {number} [end] - epoch ms
     * @returns {Promise}
     */
    getMonthUsages = (start, end) => {
        const qs = start && end ? `?start=${start}&end=${end}` : '';
        const url = `${baseUrl}/${service}/usage/months${qs}`;
        const cfg = { headers: { Authorization: `Bearer ${this.getToken()}` } };
        return agent.get(url, cfg);
    };

    /**
     * Requests a rebuild of quarter slots + day usage, single day when end is omitted.
     * @param {string} meterType - e.g. 'Power_Meter'
     * @param {number} start - epoch ms
     * @param {number|null} [end] - epoch ms, exclusive
     * @returns {Promise}
     */
    postQuarterSlot = (meterType, start, end) => {
        const url = `${baseUrl}/${service}/quarter/slot`;
        const data = { meterType, start };
        if (end) data.end = end;

        const cfg = { headers: { Authorization: `Bearer ${this.getToken()}`, 'Content-Type': 'application/json' } };
        return agent.post(url, { data }, cfg);
    };
}

const homeWizardService = new HomeWizardService();
export default homeWizardService;
